import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  BaseCard,
  BaseCardBody,
  BaseCardHeader,
  Pager,
} from '@unite-us/ui';
import { browserHistory } from 'common/utils/browserHistory';
import { get, isEmpty, wget } from 'lodash';
import { fetchContactReferrals } from 'actions/Referral/Contact/Group';
import { Spinner } from 'common/spinners';
import ReferralTableView from 'src/components/Facesheet/Referrals/ReferralTableView';
import NoReferralsView from 'src/components/Facesheet/Referrals/NoReferralsView';
import { loadDashboardSortingConfiguration } from 'src/components/Dashboard/utils/userSortingHandler';
import { createSortChangeHandler } from 'src/components/Dashboard/utils/sortHelpers';
import 'src/components/Facesheet/Referrals/stylesheets/referrals.scss';

export class FacesheetReferrals extends Component {
  constructor(props) {
    super(props);
    const sortObj = loadDashboardSortingConfiguration(browserHistory.getCurrentLocation().pathname);
    this.fetchReferrals = this.fetchReferrals.bind(this);
    this.selectReferral = this.selectReferral.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.onPrevClick = this.onPrevClick.bind(this);
    this.state = {
      fetching: false,
      page: 1,
      sidx: sortObj?.column || 'updated_at',
      sord: sortObj?.sortDirection || 'desc',
      currentFetchId: 0,
    };
  }

  componentDidMount() {
    this.fetchReferrals();
  }

  onSortChange = createSortChangeHandler(this);

  onNextClick() {
    const page = this.state.page + 1;
    this.setState({ page }, () => {
      this.fetchReferrals(page);
    });
  }

  onPrevClick() {
    const page = this.state.page - 1;
    this.setState({ page }, () => {
      this.fetchReferrals(page);
    });
  }

  fetch(page = 1, sortBy = this.state.sidx, sortDirection = this.state.sord) {
    this.fetchReferrals(page, sortBy, sortDirection);
  }

  fetchReferrals(page = 1, sortBy = this.state.sidx, sortDirection = this.state.sord) {
    const { contactId } = this.props;
    const fetchId = this.state.currentFetchId + 1;
    this.setState({
      fetching: true,
      page,
      sidx: sortBy,
      sord: sortDirection,
      currentFetchId: fetchId,
    }, () => (
      this.props.fetchContactReferrals(
        null,
        contactId,
        { page, sortBy, sortDirection },
      )
        .then(() => {
          // Only update if this is still the most recent fetch
          if (this.state.currentFetchId === fetchId) {
            this.setState({ fetching: false });
          }
        })
    ));
  }

  selectReferral(rowNumber) {
    const { referrals } = this.props;
    const selectedReferral = referrals[rowNumber];
    browserHistory.push(`/referrals/${selectedReferral.id}`);
  }

  render() {
    const {
      referrals,
      groupId,
      isCC,
      paging,
    } = this.props;
    const { fetching } = this.state;

    let content;

    if (fetching) {
      content = <Spinner />;
    } else if (!isEmpty(referrals)) {
      content = (
        <ReferralTableView
          referrals={referrals}
          groupId={groupId}
          isCC={isCC}
          sortBy={this.state.sidx}
          sortDirection={this.state.sord}
          fetchReferrals={this.fetchReferrals}
          onSortChange={this.onSortChange}
        />
      );
    } else {
      content = <NoReferralsView />;
    }

    return (
      <BaseCard>
        <BaseCardHeader title={<span className="text-base font-semibold leading-6 text-brand-blue">Referrals</span>}>
          {
            referrals.length > 0 && (
              <div className="facesheet-cases__pagination">
                <Pager
                  paging={paging}
                  disabled={fetching}
                  onNextClick={this.onNextClick}
                  onPrevClick={this.onPrevClick}
                />
              </div>
            )
          }
        </BaseCardHeader>
        <BaseCardBody>
          {content}
        </BaseCardBody>
      </BaseCard>
    );
  }
}
FacesheetReferrals.propTypes = {
  contactId: PropTypes.string.isRequired,
  fetchContactReferrals: PropTypes.func.isRequired,
  groupId: PropTypes.string.isRequired,
  isCC: PropTypes.bool.isRequired,
  referrals: PropTypes.array,
  paging: PropTypes.object.isRequired,
};

FacesheetReferrals.defaultProps = {
  referrals: [],
};

function mapStateToProps(state, ownProps) {
  const {
    contactReferrals,
    session: { groupId },
  } = state;
  const contactId = ownProps.params.id;
  const isCC = wget(state, 'session.isCoordinationGroup');
  const paging = get(contactReferrals, 'paging', {});

  return {
    contactId,
    groupId,
    isCC,
    referrals: get(contactReferrals, [contactId, 'data'], []),
    paging,
  };
}

export default connect(mapStateToProps, {
  fetchContactReferrals,
})(FacesheetReferrals);
